import { useQuery } from '@tanstack/react-query'
import { requestGET } from '../services/request'
import { useOrganizationView } from '../components/organizationView/useOrganizationView'
import { useMemo } from 'react'
import { useAuth0 } from '@auth0/auth0-react'
import { brandColors } from '../theme'

export const useOrganizations = () => {
  const auth = useAuth0()
  return useQuery([`organizationsQuery`], async () =>
    requestGET(`organization`, undefined, auth),
  )
}

export const useIsHeartEyeOrganization = (): boolean => {
  const { user } = useAuth0()
  const orgName: string | null = useMemo(
    () => user?.[`${process.env.GATSBY_AUTH_NAMESPACE}/org_name`],
    [user],
  )
  return /hearteye/i.test(orgName || ``)
}

export const useIsTopLevelOrganization = (): boolean => {
  const { orgData } = useOrganizationView()
  return !orgData?.parentId
}

export const useIsAssessorOrganization = (): {
  isAssessor: boolean
  isLoading: boolean
} => {
  const { orgData, orgLoading } = useOrganizationView()
  const isHearteyeTenant = useIsHeartEyeOrganization()
  const isTopLevelOrganization = useIsTopLevelOrganization()

  return {
    isAssessor:
      !!(
        !Array.isArray(orgData?.assessorOrgIds) ||
        orgData?.assessorOrgIds.length === 0
      ) &&
      isHearteyeTenant &&
      !isTopLevelOrganization,
    isLoading: orgLoading,
  }
}

export const useOrganizationTheme = (orgName: string) => {
  switch (true) {
    case orgName.includes('orion'):
      return {
        main: '#5F4C8D',
        contrast: '#FFFFFF',
      }
    case orgName.includes('tno'):
      return {
        main: '#002484',
        contrast: '#FFFFFF',
      }

    default:
      return {
        main: brandColors[6],
        contrast: '#000000',
      }
  }
}
